import { defineSlotRecipe as t } from "@pandacss/dev";
const o = t({
  className: "alert",
  slots: ["root", "content", "description", "icon", "title", "size"],
  base: {
    root: {
      background: "bg.default",
      borderWidth: "1px",
      borderRadius: "l3",
      display: "flex",
      gap: "spacing-3",
      p: "spacing-4"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "spacing-1"
    },
    description: {
      color: "fg.muted",
      textStyle: "sm"
    },
    icon: {
      color: "fg.default",
      flexShrink: "0",
      width: "spacing-5",
      height: "spacing-5"
    },
    title: {
      color: "fg.default",
      fontWeight: "semibold",
      textStyle: "sm"
    }
  }
});
export {
  o as alert
};
